/**
 * [EN] White is `0` so it stays the default: the form's initial value is the first member. The
 *      ordinals are BE `theme`'s (Dark = 0 / Light = 1), which is how this travels to the API.
 * [KO] white 를 `0` 으로 두어 기본값이 되게 한다. 폼 초기값이 첫 멤버이기 때문이다. 순서값은 BE
 *      `theme`(Dark = 0 / Light = 1)과 같고, API 로는 그 값으로 오간다.
 */
export enum TextColorType {
  WHITE,
  BLACK,
}

export enum TabType {
  CURRENT,
  NEW,
}

export interface TextFormData {
  title: string;
  subtitle: string;
}

export interface LinkFormData {
  url: string;
  tab: string;
}

export interface MainBannerFormData {
  bannerName: string;
  image: File | null;
  text: TextFormData;
  textColor: string;
  link: LinkFormData;
  isShow: boolean;
}

/**
 * [EN] Each field carries its message, not a boolean: one field now fails for more than one reason
 *      (Link is optional but must be a URL and stay under 200 chars), and a boolean cannot say
 *      which. An empty string means valid.
 * [KO] 필드마다 boolean 이 아니라 메시지를 든다. 한 필드가 여러 이유로 실패하기 때문이다 (Link 는
 *      선택 입력이지만 URL 형식이어야 하고 200자를 넘지 않아야 한다) — boolean 은 어느 쪽인지
 *      말하지 못한다. 빈 문자열이 유효를 뜻한다.
 */
export interface MainBannerFormValidation {
  bannerName: string;
  image: string;
  title: string;
  subtitle: string;
  link: string;
}
